export enum DROPDOWN_POSITION_ENUM {
    TOP = 'top',
    BOTTOM = 'bottom'
}
